import { render, staticRenderFns } from "./TableService.vue?vue&type=template&id=bdee980a&scoped=true&"
import script from "./TableService.vue?vue&type=script&lang=js&"
export * from "./TableService.vue?vue&type=script&lang=js&"
import style0 from "./TableService.vue?vue&type=style&index=0&id=bdee980a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdee980a",
  null
  
)

export default component.exports